module.exports = __webpack_public_path__ + "img/cxample_15.6b7f9d5a.png";